// src/modules/app-views/services/pages/Document/tabs/AiInfoTab/TaxRetentionsSection.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Flex, Descriptions, Collapse, theme } from 'antd';
import { SafetyOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import { DEFAULT_OPEN_KEYS } from './index';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const TaxRetentionsSection = ({ data, aiResponse, isMobile }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { token } = theme.useToken();
  const tr = aiResponse?.taxRetentions;

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. LOCAL VARIABLES
  // ─────────────────────────────────────────────────────────────────────────────
  const hasData = tr && (
    tr.pisTaxRate !== undefined ||
    tr.cofinsTaxRate !== undefined ||
    tr.csllTaxRate !== undefined ||
    tr.irrfTaxRate !== undefined ||
    tr.inssTaxRate !== undefined
  );

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. UI
  // ─────────────────────────────────────────────────────────────────────────────
  if (!hasData) return null;

  return (
    <Collapse
      className="collapsed-content-fit"
      defaultActiveKey={DEFAULT_OPEN_KEYS.includes('tax-retentions') ? ['tax-retentions'] : []}
      style={{ marginBottom: 16 }}
      items={[
        {
          key: 'tax-retentions',
          label: (
            <Flex align="center" gap={8}>
              <SafetyOutlined style={{ color: token.colorPrimary }} />
              <span style={{ fontWeight: 600 }}>{translateX('tax_retentions')}</span>
            </Flex>
          ),
          showArrow: false,
          children: (
            <Descriptions
              bordered
              size="small"
              column={1}
              layout={isMobile ? 'vertical' : 'horizontal'}
              styles={{ label: { fontWeight: 500 } }}
            >
              {tr.pisTaxRate !== undefined && (
                <Descriptions.Item label="PIS">{tr.pisTaxRate}%</Descriptions.Item>
              )}
              {tr.cofinsTaxRate !== undefined && (
                <Descriptions.Item label="COFINS">{tr.cofinsTaxRate}%</Descriptions.Item>
              )}
              {tr.csllTaxRate !== undefined && (
                <Descriptions.Item label="CSLL">{tr.csllTaxRate}%</Descriptions.Item>
              )}
              {tr.irrfTaxRate !== undefined && (
                <Descriptions.Item label="IRRF">{tr.irrfTaxRate}%</Descriptions.Item>
              )}
              {tr.inssTaxRate !== undefined && (
                <Descriptions.Item label="INSS">{tr.inssTaxRate}%</Descriptions.Item>
              )}
            </Descriptions>
          ),
        },
      ]}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default TaxRetentionsSection;
